import {BaseView} from "../core/view";
import {TrackingUtil} from "../utils/tracking";
import {SearchList} from "../utils/data-structures";
import {MobileUtil} from "../utils/mobile";

export default BaseView.extend({

    el: '.js-header-search',

    events: {
        'click .js-toggle-disclaimer': 'toggleLegalDisclaimerTooltip',
        'click .js-disclaimer-tooltip': 'hideLegalDisclaimerTooltip',
		'click .js-breadcrumb-link': 'breadcrumbClick',
        'click .js-description-expand': 'calculateOnCollapse'
    },

	initialize: function(){
        if(this.el){
            this.calculateReadMore.call(this);

            window.addEventListener("resize", this.calculateReadMore.bind(this));
        }
	},

    calculateOnCollapse: function(e){
        this.el && !e.currentTarget.checked && this.calculateReadMore.call(this);
    },

	 toggleLegalDisclaimerTooltip: function(e) {
		const disclaimerTooltip = this.el.querySelector('.js-disclaimer-tooltip');
		if (disclaimerTooltip) {
			const classList = disclaimerTooltip.classList;

			if (!classList.contains('header-search__disclaimer-tooltip--visible')) {
				TrackingUtil.throwGAEvent('Show Search Disclaimer', 'Click', '', false);
			}

			classList.toggle('header-search__disclaimer-tooltip--visible');
		}
	 },

	 hideLegalDisclaimerTooltip: function(e) {
		const disclaimerTooltip = e.currentTarget;
		if (disclaimerTooltip) {
			disclaimerTooltip.classList.remove('header-search__disclaimer-tooltip--visible');
		}
	 },

    breadcrumbClick: function(e){
    	TrackingUtil.throwGAEvent('Breadcrumb', 'Click', e.currentTarget.getAttribute('data-link'), false);
	},

	calculateReadMore: _.throttle(async function(){
        const seoDescription = this.el.querySelector('.js-seo-description');
        const readLabel = this.el.querySelector('.js-read-label');
        if(MobileUtil.isMobile() && seoDescription && readLabel){
            seoDescription.innerHTML = Array.prototype.map.call(seoDescription.textContent, (c => `<span>${c}</span>`)).join('');
            let list = new SearchList([...seoDescription.children]);
            readLabel.style.width = null;
            const rectRead = readLabel.getBoundingClientRect();
            let borderCharacter = list.binarySearch(c => {
                const rectC = c.getBoundingClientRect();
                if(Math.floor(rectC.top) < Math.floor(rectRead.top)) return -1;
                if(Math.floor(rectC.bottom) > Math.floor(rectRead.bottom)) return 1;
                if(rectC.left < rectRead.left && rectC.right > rectRead.left) return 0;
                if(rectC.left < rectRead.left && rectC.right < rectRead.left) return -1;
                else return 1;
            });

            if(borderCharacter){
                readLabel.style.width = `${rectRead.width + (rectRead.left - borderCharacter.getBoundingClientRect().left)}px`;
            }

            seoDescription.innerHTML = Array.prototype.map.call(seoDescription.children, (c => c.textContent)).join('');
        }
	}, 300)

});